// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59cee3ad","455":"f6d03b53","977":"4043fe10"}[chunkId] + ".chunk.js";
};